<template>
    <div>
        <div class="banner banner--theme banner--generic" :style="{ backgroundImage: 'url(' + data.background + ')' }">
            <div class="banner-primary">
                <div class="container">
                    <div class="col-content">
                        <div class="banner-content">
                            <h1>{{data.title}}</h1>
                            <!-- <p v-html="data.content"></p> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="banner-intro-text">
            <div class="container">
                <div class="row">
                    <div class=" col-xs-12 col-sm-12 col-xl-6" v-html="data.content"></div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "banner-image",
        props: {
            data: {
                type: Object
            }
        },
        data() {
            return {

            };
        },
        computed: {

        },
        methods: {

        },
        mounted() {

        }
    };
</script>

<style lang="scss" scoped>
    @import "../../../scss/abstracts/variables";

    .banner--generic {
        position: relative;
        //max-height: auto;
        max-height: 380px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        background-color: $brand-blue;

        @media #{$lg} {
            max-height: 380px;
        }

        .container {
            display: block;

            @media #{$lg} {
                display: flex;
            }

            .col-content {
                width: 100%;
                display: block;


                @media #{$lg} {
                    width: 60%;
                    display: flex;
                    align-items: center;
                }

                .banner-content {
                    max-width: 100%;
                    margin-top: 0;

                    @media #{$lg} {
                        max-width: 450px;
                        margin-top: 60px;
                    }
                }
            }
        }

        .banner-primary {
            .container {
                .col-content {
                    height: auto;
                    padding: 120px 0 60px 0;

                    @media #{$lg} {
                        height: 380px;
                        padding: 0;
                    }
                }
            }
        }
    }

    //@media #{$sm} {}
    //@media #{$md} {}
    //@media #{$lg} {}
    //@media #{$xl} {}

</style>
